import { render } from "./index.vue?vue&type=template&id=d34244e4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d34244e4&lang=css"

import exportComponent from "D:\\work\\依申请公开平台\\前台\\apply-to-the-front-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__